<template>
  <div class="step item-box-430">
    <h2 class="title">审批明细</h2>
    <div v-for="(item, key) in audit" :key="key" class="flex item start">
      <div class="icon">
        <Icon
          :type="getIconType(item, key)"
          size="32"
          :color="getColor(item)"
        ></Icon>
      </div>
      <div class="content">
        <p>{{ item.checkStep | initStepStr }}</p>
        <p class="time">{{ item.createTime }}</p>
      </div>
      <div v-if="getStepStatus(item) != '待结算'" class="status">
        <p :style="{ color: getColor(item) }">{{ getStepStatus(item) }}</p>
        <p class="name">{{ item | initCheckerName }}</p>
      </div>
      <div v-if="getStepStatus(item) == '待结算'" class="status">
        <Button
          v-if="detailsData.bankId == '0' && portOrg == 0"
          type="info"
          size="small"
          @click="handleWxCheck"
        >结算管理</Button>
      </div>
    </div>
    <!-- <div class="flex item end" v-if="inShowEnd">
      <div class="icon"><Icon type="ios-disc" size="32" color="#488ffa" /></div>
      <div class="content">
        <p>监管银行结算</p>
      </div>
    </div> -->

    <!-- <div
      class="org-check-fail"
      v-if="detailsData.approvalSts == 5 && (portOrg == 3 || portOrg == 2)"
    >
      <div class="flex" style="margin-bottom: 6px; align-items: center">
        <span style="font-weight: bold">机构驳回</span>
        <Button
          type="error"
          style="margin-left: 16px"
          size="small"
          @click="handleOrgCfm"
          v-auth="`CONFIRM_SETTLEMENT`"
          >核销无误，确认账单</Button
        >
      </div>
      <p style="color: #999">{{ orgFailTiem }}</p>
    </div> -->
    <WeChatCheck
      ref="weChatCheckRef"
      :table-data="tableData"
      @on-success="onWechatCheckSuccess"
    ></WeChatCheck>
  </div>
</template>

<script>
import { getColumn } from '../data/SettlementDetailsTable';
import orderCenterApi from '@/request/orderCenter/index.js';
import WeChatCheck from './WeChatCheck';
export default {
  components: {
    WeChatCheck
  },
  filters: {
    initCheckerName(item) {
      if ([1, 2, 3, 4, 7].includes(item.checkStep)) {
        return item.checkerName;
      }
    },
    initStepStatus(item) {
      const str = '未确认';
      if (item.checkStep == 1 && item.checkResult == 1) {
        return '已确认';
      }
      if (item.checkStep == 6 && item.checkResult == 1) {
        return '已结算';
      }
      if (item.checkStep != 6) {
        switch (Number(item.checkResult)) {
          case 1:
            return '审批通过';
            break;
          case 2:
            return '审批驳回';
            break;
        }
      } else {
        switch (Number(item.checkResult)) {
          case 3:
            return '已结算';
            break;
          case 4:
            return '审批驳回';
            break;
          case 5:
            return '待结算';
            break;
        }
      }

      return str;
    },
    initStepStr(step) {
      const str = '机构确认结算单';
      switch (Number(step)) {
        case 1:
          return '机构确认结算单';
          break;
        case 2:
          return '学校审核';
          break;
        case 3:
          return '预审';
          break;

        case 4:
          return '教育局复审';
          break;
        case 5:
          return '运营审核';
          break;
        case 99:
          return '监管银行结算';
          break;
        case 7:
          return '收款单位确认';
      }
      return str;
    }
  },
  inject: ['detailsData', 'tableType'],
  beforeRouteEnter() {

  },
  props: {
    audit: {
      type: Array,
      default: () => []
    },
    tableData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      // tableType: 1: 运营平台 - 机构端->机构 2:运营平台 - 学校端 ->学校 3:教育局

    };
  },
  data() {
    return {
      approvalSts: '',
      portOrg: localStorage.getItem('portOrg')
    };
  },
  computed: {
    inShowEnd() {
      return this.audit.findIndex(item => { return item.checkStep == 4 && item.checkResult == 1; }) > -1;
    },
    orgFailTiem() {
      const orgFails = this.audit.filter(item => { return item.checkStep == 1 && item.checkResult == 2; });
      return orgFails.length > 0 ? orgFails[orgFails.length - 1]['createTime'] : '';
    },
    orgId() {
      return this.detailsData.tableType == 1 ? this.detailsData.data.orgId : this.detailsData.data.schId;
    }

  },
  created() {

  },
  methods: {
    getIconType(val, key) {
      if (key == 0) {
        return 'ios-disc';
      }
      switch (Number(val.checkResult)) {
        case 1:
          return 'ios-checkmark-circle';
          break;
        case 2:
          return 'ios-close-circle';
          break;
        case 3:
          return 'ios-checkmark-circle';
          break;
        case 4:
          return 'ios-close-circle';
          break;
        case 5:
          return 'ios-disc';
          break;
      }
    },

    getColor(val) {
      switch (Number(val.checkResult)) {
        case 1:
          return '#488ffa';
          break;
        case 2:
          return '#ed4014';
          break;
        case 3:
          return '#488ffa';
          break;
        case 4:
          return '#ed4014';
          break;
        case 5:
          return '#488ffa';
          break;
      }
    },
    handleWxCheck() {
      this.$refs.weChatCheckRef.handleShow();
    },
    // 更改状态刷新页面更改跳转
    handleLoadRoute() {
      const detailsData = JSON.parse(JSON.stringify(this.detailsData));
      detailsData.approvalSts = this.approvalSts;
      const routeName = this.$route.name;
      console.log(routeName, detailsData);
      const routeUrl = this.$router.resolve({
        name: routeName,
        query: {
          detailsData: encodeURIComponent(JSON.stringify(detailsData))
        }
      });

      window.location.href = routeUrl.href;
      window.location.reload();
    },
    // 机构端提交
    handleOrgCfm() {
      this.$Modal.confirm({
        title: '温馨提示',
        content: '<p>是否提交确认？</p>',
        onOk: () => {
          console.log('{ statementId: this.statementId }', { statementId: this.detailsData.sheetId, orgId: this.orgId });
          this.$Spin.show();
          orderCenterApi.saveOrgSettlementSheetconfirm({ statementId: this.detailsData.sheetId, orgId: this.orgId }).then(res => {
            this.$Spin.hide();
            if (res.status == 200) {
              //  this.approvalSts = 3

              // encodeURIComponent(query)
              this.$Message.success('提交成功');
              this.handleLoadRoute();
            }
          });
        }
      });
    },
    // 微信账单核对成功
    async onWechatCheckSuccess() {
      //   this.statementSts = 1
      this.approvalSts = await this.getSettlementSheetStatus(this.detailsData.sheetId);
      this.handleLoadRoute();
    },
    getStepStatus(item) {
      const str = '未确认';
      if (item.checkStep == 1 && item.checkResult == 1) {
        return '已确认';
      }
      if (item.checkStep == 6 && item.checkResult == 1) {
        return '已结算';
      }
      if (item.checkStep != 6) {
        switch (Number(item.checkResult)) {
          case 1:
            return '审批通过';
            break;
          case 2:
            return '审批驳回';
            break;
        }
      } else {
        switch (Number(item.checkResult)) {
          case 3:
            return '已结算';
            break;
          case 4:
            return '审批驳回';
            break;
          case 5:
            return '待结算';
            break;
        }
      }

      return str;
    }
  }

};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/common';
.flex {
  display: flex;
}
.title {
  font-size: 22px;
  margin-bottom: 16px;
}
.item {
  padding-bottom: 32px;
  &:last-child {
    .icon {
      &:before {
        width: 0px;
      }
    }
  }
  .icon {
    margin-right: 8px;
    position: relative;
    &:before {
      position: absolute;
      content: '';
      display: inline-block;
      width: 1px;
      height: 50px;
      background: #eee;
      top: 29px;
      left: 50%;
    }
  }
  .content {
    width: 140px;
  }
  .content,
  .status {
    margin-right: 32px;
    p {
      margin-bottom: 8px;
      font-weight: bold;
    }
    .time,
    .name {
      font-weight: 400;
      color: #999;
    }
  }
  &.end {
    .content {
      display: flex;
      align-items: center;
    }
  }
}
.step {
  position: relative;
}
.org-check-fail {
  position: absolute;
  top: 50px;
  right: 30%;
}
</style>
